<template>
  <Teleport to="body">
    <div v-if="modelValue" class="b-pop-up">
      <div :class="backgroundClass">
        <div v-if="!hideHeader" :class="headerBackgroundClass">
          <slot name="header"></slot>

          <CloseModal
            v-if="!hideCloseBtn"
            class="b-pop-up__close"
            @close="closeModal" />
        </div>
        <slot name="body"></slot>
        <div v-if="videoModal || photoGalleryModal" class="b-pop-up__content">
          <div class="b-pop-up__swiper-holder">
            <Swiper
              :navigation="{
                nextEl: '.pop-up-trailer__next',
                prevEl: '.pop-up-trailer__prev',
              }"
              :pagination="{
                el: '.pop-up-trailer__pagination',
                type: 'bullets',
                clickable: true,
              }"
              slides-per-view="1"
              :space-between="30"
              :initial-slide="initialSlideIndex"
              @slide-change="onSlideChange">
              <SwiperSlide v-for="(item, index) in swiperData" :key="index">
                <div v-if="videoModal" class="b-pop-up__iframe-wrapper">
                  <iframe
                    width="1174"
                    height="660"
                    :src="`https://www.youtube-nocookie.com/embed/${item}`"
                    title="YouTube trailer video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
                </div>
                <div v-if="photoGalleryModal" class="b-pop-up__img-wrapper">
                  <img :src="item" alt="photo gallery" />
                </div>
              </SwiperSlide>
              <div v-if="swiperData.length > 1" class="swiper__nav">
                <div class="swiper-button-prev pop-up-trailer__prev"></div>
                <div class="swiper-pagination pop-up-trailer__pagination"></div>
                <div class="swiper-button-next pop-up-trailer__next"></div>
              </div>
              <div v-if="photoGalleryModal && downloadablePhotos">
                <a
                  class="b-pop-up__icon-download"
                  :href="activeSlide"
                  download
                  :aria-label="linkDownloadText">
                  <i class="icon-download"></i>
                </a>
              </div>
            </Swiper>
          </div>
        </div>
      </div>
      <div class="b-pop-up--backdrop" @click="closeModalFromBackdrop"></div>
    </div>
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watchEffect } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import CloseModal from './UI/CloseModal.vue'
const emit = defineEmits(['update:modelValue', 'close'])

const activeSlide = ref('')

const props = defineProps({
  modelValue: { default: false, type: Boolean },
  size: { default: 'medium', type: String },
  noCloseBackdrop: { default: false, type: Boolean },
  hideHeader: { default: false, type: Boolean },
  hideCloseBtn: { default: false, type: Boolean },
  backgroundClass: { default: 'b-pop-up__holder', type: String },
  headerBackgroundClass: { default: 'b-pop-up__title-holder', type: String },
  videoModal: { default: false, type: Boolean },
  photoGalleryModal: { default: false, type: Boolean },
  swiperData: {
    default() {
      return []
    },
    type: Array,
  },
  downloadablePhotos: { default: false, type: Boolean },
  initialSlideIndex: { default: 0, type: Number },
  linkDownloadText: { default: '', type: String },
})

const unwatch = watchEffect(() => {
  if (props.modelValue) {
    document.body.classList.add('b-pop-up__modal-open')
  } else {
    document.body.classList.remove('b-pop-up__modal-open')
  }
})

const closeModal = () => {
  emit('update:modelValue', !props.modelValue)
  emit('close', !props.modelValue)
}

const closeModalFromBackdrop = () => {
  if (!props.noCloseBackdrop) {
    closeModal()
  }
}

onMounted(() => {
  activeSlide.value = props.swiperData[0]
})

onBeforeUnmount(() => {
  jQuery(document).off('keyup.modal')
  document.body.classList.remove('b-pop-up__modal-open')
  unwatch()
})

const onSlideChange = (slide) => {
  activeSlide.value = props.swiperData[slide.activeIndex]
}
</script>
